import React, { useMemo, useState } from 'react';
import OlcActionMenu from '~/components/General/OlcActionMenu';
import OlcButton from '~/components/General/OlcButton';
import { Link } from 'react-router-dom';

// MUI
import {
  Box,
  Chip,
  Divider,
  Grid,
  GlobalStyles,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Typography,
  Avatar,
  Paper,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// Assets
import {
  GeneralPencilCIcon,
  GeneralCrossCIcon,
  GeneralArchiveCIcon,
  GeneralRestoreCIcon,
} from '~/assets/images';

// Modal
import CreateSubCompany from './CreateSubCompany';
import ArchiveModal from './ArchiveModal';

// Styles
import './styles.scss';

const mockCompanies = [
  { id: 1, name: 'A Company', address: '123 Business Rd, Biztown, ST 54132', archived: false },
  { id: 2, name: 'B Company', address: '123 Business Rd, Biztown, ST 54132', archived: false },
  { id: 3, name: 'C Company', address: '123 Business Rd, Biztown, ST 54132', archived: false },
  { id: 4, name: 'D Company', address: '123 Business Rd, Biztown, ST 54132', archived: false },
  { id: 5, name: 'F Company', address: '123 Business Rd, Biztown, ST 54132', archived: true },
];

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00ffffff).toString(16).toUpperCase();
  return '#' + '00000'.substring(0, 6 - c.length) + c;
};

const getInitials = (name) => {
  const parts = name.split(' ').filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const SubCompanies = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openArchiveModal, setOpenArchiveModal] = useState(false);

  const openMenu = Boolean(anchorEl);

  const companies = useMemo(() => mockCompanies, []);

  const handleMenuOpen = (event, company) => {
    setAnchorEl(event.currentTarget);
    setMenuFor(company);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuFor(null);
  };

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: '#f9fafb' } }} />
      <Box className="olcWrapper">
        <Box className="olcScreenCard" style={{ paddingBottom: '25px' }}>
          <Box className="headerWrap olcHeaderWrap">
            <Box>
              <Typography className="pageTitle">Sub-Companies</Typography>
            </Box>
            <Box className="pageNewBtn">
              <OlcButton variant="primary" onClick={() => setOpenCreateModal(true)}>
                Add New
              </OlcButton>
            </Box>
          </Box>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper className="subCompaniesCard">
                <List disablePadding className="companyList">
                  {companies.map((c, idx) => (
                    <div key={c.id}>
                      <ListItem
                        className={`companyItem ${c.archived ? 'archived' : ''}`}
                        secondaryAction={
                          <IconButton
                            edge="end"
                            onClick={(e) => handleMenuOpen(e, c)}
                            aria-label={`Open actions for ${c.name}`}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        }
                      >
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: stringToColor(c.name) }} className="companyAvatar">
                            {getInitials(c.name)}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Box className="companyTitle">
                              <Typography
                                className="companyName"
                                component={Link}
                                to={`/company/sub-companies/${c.id}`}
                              >
                                {c.name}
                              </Typography>
                              {c.archived && (
                                <Chip label="Archived" size="small" className="archivedChip" />
                              )}
                            </Box>
                          }
                          secondary={
                            <Typography className="companyAddress">{c.address}</Typography>
                          }
                        />
                      </ListItem>
                    </div>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>

          <OlcActionMenu
            id="company-actions-menu"
            MenuListProps={{
              'aria-labelledby': 'company-actions-button',
            }}
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {!menuFor?.archived ? (
              <>
                <MenuItem onClick={handleMenuClose}>
                  <img src={GeneralPencilCIcon} alt="edit" />
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    setOpenArchiveModal(true);
                  }}
                >
                  <img src={GeneralArchiveCIcon} alt="archive" />
                  Archive
                </MenuItem>
              </>
            ) : (
              <MenuItem onClick={handleMenuClose}>
                <img src={GeneralRestoreCIcon} alt="restore" />
                Restore
              </MenuItem>
            )}
          </OlcActionMenu>

          <CreateSubCompany
            openModal={openCreateModal}
            handleCloseModal={() => setOpenCreateModal(false)}
          />
          <ArchiveModal
            openModal={openArchiveModal}
            handleCloseModal={() => setOpenArchiveModal(false)}
            onConfirm={() => Promise.resolve()}
          />
        </Box>
      </Box>
    </>
  );
};

export default SubCompanies;
